import React from "react";
import "./Plans.css";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";
import rightArrow from "../../assets/rightArrow.png";
import { Link } from "react-scroll";

const Plans = () => {
  return (
    <div className="plans-container" id="Plans">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div className="program-header" style={{ gap: "2rem" }}>
        <span className="outline-text">ready to start</span>
        <span>your journey</span>
        <span className="outline-text">now with us</span>
      </div>

      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>₹ {plan.price}</span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>

            <div class="bfit">
              <span>see more benefits</span>
              <img src={rightArrow} alt="" />
            </div>
            <button className="btn">
              <Link to="join" span={true} smooth={true}>
                Join Now
              </Link>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
